module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md7": "",
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Tipo:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTypeAndCodeRoom(_vm.bookingData)))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Noches:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingData.numberNights))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Niños:")]), _vm._v(" "), _c('span', [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/child-icon.svg"),
      "alt": ""
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.bookingData.summary.booking.childrens) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('p', [_vm._v("Adultos:")]), _vm._v(" "), _c('span', [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/adult-icon.svg"),
      "alt": ""
    }
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.bookingData.summary.booking.adults) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "py-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("CHECKIN")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.bookingData.bookingStart, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('p', [_vm._v("CHECKOUT")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.bookingData.bookingEnd, 'DD/MM/YYYY')))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pa-0": ""
    }
  }, [_c('span', {
    staticClass: "booking-number"
  }, [_vm._v("Nº RESERVA\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.numReservation))])])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs",
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "transparent"
  }, [_c('v-tabs-slider', {
    staticClass: "default-skyblue"
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-tabs-item', {
      key: item.id,
      attrs: {
        "href": '#tab-' + item.id,
        "disabled": (!_vm.saleId || _vm.saleId < 1) ||
          _vm.isNoShow
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.title) + " "), (item.id === 3) ? _c('span', [_vm._v("(" + _vm._s(_vm.totalNotes) + ")")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('v-tabs-items', _vm._l((_vm.items.length), function(i) {
    return _c('v-tabs-content', {
      key: i,
      attrs: {
        "id": 'tab-' + i
      }
    }, [(i === 1) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("Nº 1")])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNº Tarjeta:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bookingData.customer.data.cardVip),
        expression: "bookingData.customer.data.cardVip"
      }]
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tVip\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bookingData.customer.data.cardVip),
        expression: "bookingData.customer.data.cardVip"
      }]
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.bookingData.customer.data.cardVip) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_c('app-type-document', {
      attrs: {
        "document-id": _vm.bookingData.customer.data.documentType
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.numDocument))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNombre:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tApellido:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.lastname))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tFec. Nac.:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.bookingData.customer.data.dateBirth, 'DD/MM/YYYY')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t- Adulto")])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item no-border"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tPaís:\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.bookingData.customer.data.country.data.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item no-border"
    }, [_c('v-icon', {
      staticClass: "bar-icon warning--text"
    }, [_vm._v("start")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.showCustomerData(_vm.bookingData.customer.data, true)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.$imageS3 + "/clerkinn/edit-icon.svg"),
        "alt": ""
      }
    })])], 1)])]), _vm._v(" "), (!_vm.additionalCustomersIsEmpty) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "pa-0": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.bookingData.customerAditional), function(customer, customerIndex) {
      return _c('v-flex', {
        key: customer.id,
        attrs: {
          "xs12": "",
          "mt-3": ""
        }
      }, [_c('div', {
        staticClass: "bar-data"
      }, [_c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v("Nº " + _vm._s(customerIndex + 2))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tNº Tarjeta:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (customer.cardVip),
          expression: "customer.cardVip"
        }]
      }, [_vm._v("Vip")]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (customer.cardVip),
          expression: "customer.cardVip"
        }]
      }, [_vm._v(_vm._s(customer.cardVip))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDNI:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.numDocument))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tNombre:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.name))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tApellido:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.lastname))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tFec. Nac.:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(customer.dateBirth, 'DD/MM/YYYY')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t- " + _vm._s(customer.flagPerson))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item no-border"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tPaís:\n\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(customer.country))])])]), _vm._v(" "), _c('div', {
        staticClass: "bar-data-item no-border"
      }, [_c('v-btn', {
        staticClass: "grey--text",
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            _vm.changeMainCustomer(customer)
          }
        }
      }, [_c('v-icon', {
        staticClass: "bar-icon"
      }, [_vm._v("start")])], 1), _vm._v(" "), _c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            _vm.showCustomerData(customer)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": (_vm.$imageS3 + "/clerkinn/edit-icon.svg"),
          "alt": ""
        }
      })]), _vm._v(" "), _c('v-btn', {
        staticClass: "red--text",
        attrs: {
          "icon": "",
          "disabled": _vm.customerForm
        },
        on: {
          "click": function($event) {
            _vm.openDeleteCustomer(customerIndex, customer)
          }
        }
      }, [_c('v-icon', {
        staticClass: "bar-icon"
      }, [_vm._v("close")])], 1)], 1)])])
    }))], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm9": "",
        "md3": "",
        "mt-4": ""
      }
    }, [_c('button-create', {
      attrs: {
        "text": "Agregar huésped",
        "btn-function": "",
        "disabled": _vm.cantAddGuest
      },
      on: {
        "function-click": _vm.showGuestForm
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "md2": "",
        "mt-4": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "radio-group-transparent",
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.personType),
        callback: function($$v) {
          _vm.personType = $$v
        },
        expression: "personType"
      }
    }, [_c('v-radio', {
      attrs: {
        "disabled": _vm.customerForm,
        "label": "Adulto",
        "value": 1
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "disabled": _vm.customerForm,
        "label": "Niño(a)",
        "value": 2
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-3": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.customerForm),
        expression: "customerForm"
      }],
      attrs: {
        "xs12": "",
        "text-xs-left": "",
        "mb-2": ""
      }
    }, [_c('label', {
      staticClass: "label-title"
    }, [_vm._v("Completa los datos")])]), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.customerForm),
        expression: "customerForm"
      }],
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('v-layout', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Nº de Tarjeta")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeCards,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.typeCard),
        callback: function($$v) {
          _vm.typeCard = $$v
        },
        expression: "typeCard"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.model.cardVip),
        callback: function($$v) {
          _vm.model.cardVip = $$v
        },
        expression: "model.cardVip"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.documentType),
        callback: function($$v) {
          _vm.model.documentType = $$v
        },
        expression: "model.documentType"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": _vm.searchCustomer
      },
      model: {
        value: (_vm.model.numDocument),
        callback: function($$v) {
          _vm.model.numDocument = $$v
        },
        expression: "model.numDocument"
      }
    }), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.model.numDocument && _vm.$v.model.numDocument.$invalid &&
      _vm.$v.model.numDocument.$params.minLength) ? _c('p', {
      staticClass: "caption red--text mb-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.model.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      class: {
        'xs6': !_vm.isNaturalPersonModel
      },
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(_vm.nameModelLabel))]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.name),
        callback: function($$v) {
          _vm.model.name = $$v
        },
        expression: "model.name"
      }
    }), _vm._v(" "), (_vm.$v.model.name && _vm.$v.model.name.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.nameModelMessage) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isNaturalPersonModel) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.lastname),
        callback: function($$v) {
          _vm.model.lastname = $$v
        },
        expression: "model.lastname"
      }
    }), _vm._v(" "), (_vm.$v.model.lastname && _vm.$v.model.lastname.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "email",
        "placeholder": "nombre@mail.com",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.email),
        callback: function($$v) {
          _vm.model.email = $$v
        },
        expression: "model.email"
      }
    }), _vm._v(" "), (_vm.$v.model.email && _vm.$v.model.email.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl correo es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Fecha de nacimiento")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "pa-0": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-regular input-label-select",
      attrs: {
        "value": _vm.personTypeName,
        "hide-details": "",
        "readonly": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "pa-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "disabled": !_vm.model.numDocument,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIcon
      },
      model: {
        value: (_vm.menuBirthDate),
        callback: function($$v) {
          _vm.menuBirthDate = $$v
        },
        expression: "menuBirthDate"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha de nacimiento",
        "append-icon": _vm.arrowIconBirth,
        "append-icon-cb": _vm.toggleIconBirthDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.model.dateBirth),
        callback: function($$v) {
          _vm.model.dateBirth = $$v
        },
        expression: "model.dateBirth"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "allowed-dates": _vm.datesDisabled,
        "locale": "es-PE",
        "year-icon": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.model.dateBirth),
        callback: function($$v) {
          _vm.model.dateBirth = $$v
        },
        expression: "model.dateBirth"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult && _vm.isNaturalPersonModel),
        expression: "isAnAdult && isNaturalPersonModel"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Estado civil")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.civilStatus,
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.civilStatus),
        callback: function($$v) {
          _vm.model.civilStatus = $$v
        },
        expression: "model.civilStatus"
      }
    })], 1), _vm._v(" "), (_vm.isNaturalPersonModel) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Género")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.genders,
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.gender),
        callback: function($$v) {
          _vm.model.gender = $$v
        },
        expression: "model.gender"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("País")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.countries,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.loadCities
      },
      model: {
        value: (_vm.model.countryId),
        callback: function($$v) {
          _vm.model.countryId = $$v
        },
        expression: "model.countryId"
      }
    }), _vm._v(" "), (_vm.$v.model.countryId && _vm.$v.model.countryId.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tEl país es requerido\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Ciudad")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "items": _vm.cities,
        "item-text": "province",
        "item-value": "id",
        "hide-details": "",
        "disabled": !_vm.model.numDocument,
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.model.cityId),
        callback: function($$v) {
          _vm.model.cityId = $$v
        },
        expression: "model.cityId"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.address),
        callback: function($$v) {
          _vm.model.address = $$v
        },
        expression: "model.address"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAnAdult),
        expression: "isAnAdult"
      }],
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Teléfono")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number",
        "disabled": !_vm.model.numDocument
      },
      model: {
        value: (_vm.model.phone),
        callback: function($$v) {
          _vm.model.phone = $$v
        },
        expression: "model.phone"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      staticClass: "col-without-label",
      attrs: {
        "row": "",
        "wrap": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-cancel white--text",
      on: {
        "click": _vm.cancelAddGuest
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-save white--text",
      attrs: {
        "disabled": _vm.addGuestDisabled
      },
      on: {
        "click": _vm.addGuest
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.customerBtnText) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-divider')], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.bookingData.channel.data.name),
        expression: "bookingData.channel.data.name"
      }],
      attrs: {
        "xs12": "",
        "text-xs-left": "",
        "mb-2": ""
      }
    }, [_c('label', {
      staticClass: "label-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tDatos de " + _vm._s(_vm.bookingData.channel.data.name) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.channelHasProperties),
        expression: "channelHasProperties"
      }],
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_vm._l((_vm.bookingData.channel.data.questions), function(value, key) {
      return _c('div', {
        key: key,
        staticClass: "bar-data-item"
      }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(key) + ":\n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(value))])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": _vm.showChannelData
      }
    }, [_c('img', {
      attrs: {
        "src": (_vm.$imageS3 + "/clerkinn/edit-icon.svg"),
        "alt": ""
      }
    })])], 1)], 2), _vm._v(" "), (_vm.showChannelForm) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-3": ""
      }
    }, [_vm._l((_vm.bookingData.channel.data.inputInformations), function(field, fieldIndex) {
      return _c('v-flex', {
        key: fieldIndex,
        attrs: {
          "xs3": "",
          "text-xs-left": ""
        }
      }, [_c('label', {
        staticClass: "label-form"
      }, [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c(field.type, {
        tag: "component",
        class: {
          'filter-select': field.type === 'v-select',
            'input-border-inset': field.type === 'v-text-field'
        },
        attrs: {
          "item-text": field.items.itemText,
          "item-value": field.items.itemValue,
          "items": field.items.name
        },
        model: {
          value: (field[field.value]),
          callback: function($$v) {
            _vm.$set(field, field.value, $$v)
          },
          expression: "field[field.value]"
        }
      })], 1)
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-cancel grey white--text",
      on: {
        "click": _vm.cancelUpdateChannel
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
      staticClass: "btn-action btn-save white--text ml-2",
      on: {
        "click": _vm.updateChannel
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-divider')], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [((_vm.bookingData.bookingState === '2' || _vm.bookingData.bookingState === '7') && !_vm.lateCheckOutDisabled) ? _c('v-btn', {
      staticClass: "btn-action back",
      attrs: {
        "primary": "",
        "type": "button",
        "disabled": !_vm.lateCheckOut || _vm.disabledUpdateCheckOut
      },
      on: {
        "click": _vm.updateCheckOut
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tActualizar Check Out\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Late Check Out")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Late Check Out")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Late Check Out")])])], 1)], 1), _vm._v(" "), (_vm.lateCheckOutIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Hora")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Precio")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "radio-check-group",
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.lateCheckOut),
        callback: function($$v) {
          _vm.lateCheckOut = $$v
        },
        expression: "lateCheckOut"
      }
    }, _vm._l((_vm.arrayLate), function(late) {
      return _c('v-radio', {
        key: late.id,
        attrs: {
          "disabled": _vm.lateCheckOutDisabled,
          "label": ((late.hour) + " - $" + (late.price)),
          "value": late
        }
      })
    }))], 1), _vm._v(" "), (_vm.lateCheckOutIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.lateCheckOutDisabled
      },
      model: {
        value: (_vm.lateCheckOut.hour),
        callback: function($$v) {
          _vm.lateCheckOut.hour = $$v
        },
        expression: "lateCheckOut.hour"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.lateCheckOutDisabled
      },
      model: {
        value: (_vm.lateCheckOut.price),
        callback: function($$v) {
          _vm.lateCheckOut.price = $$v
        },
        expression: "lateCheckOut.price"
      }
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Early Check In")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Early Check In")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('label', {
      staticClass: "label-text"
    }, [_vm._v("Early Check In")])])], 1)], 1), _vm._v(" "), (_vm.earlyCheckInIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Hora")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Precio")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "radio-check-group",
      attrs: {
        "row": ""
      },
      model: {
        value: (_vm.earlyCheckin),
        callback: function($$v) {
          _vm.earlyCheckin = $$v
        },
        expression: "earlyCheckin"
      }
    }, _vm._l((_vm.arrayEarly), function(early) {
      return _c('v-radio', {
        key: early.id,
        attrs: {
          "disabled": _vm.bookingData.bookingState === '2',
          "label": ((early.hour) + " - $" + (early.price)),
          "value": early
        }
      })
    }))], 1), _vm._v(" "), (_vm.earlyCheckInIsSelected) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.earlyCheckinDisabled
      },
      model: {
        value: (_vm.earlyCheckin.hour),
        callback: function($$v) {
          _vm.earlyCheckin.hour = $$v
        },
        expression: "earlyCheckin.hour"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "readonly": _vm.earlyCheckinDisabled
      },
      model: {
        value: (_vm.earlyCheckin.price),
        callback: function($$v) {
          _vm.earlyCheckin.price = $$v
        },
        expression: "earlyCheckin.price"
      }
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('button-field', {
      attrs: {
        "label-text": "Cama adicional",
        "activated-button": _vm.bedSelected
      },
      on: {
        "activate-button": _vm.selectBed
      },
      model: {
        value: (_vm.aditionalBedPrice),
        callback: function($$v) {
          _vm.aditionalBedPrice = $$v
        },
        expression: "aditionalBedPrice"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('button-field', {
      attrs: {
        "label-text": "Cuna",
        "activated-button": _vm.cribSelected
      },
      on: {
        "activate-button": _vm.selectCrib
      },
      model: {
        value: (_vm.cribPrice),
        callback: function($$v) {
          _vm.cribPrice = $$v
        },
        expression: "cribPrice"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Observaciones Adicionales")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset input-textarea input-note mt-1",
      attrs: {
        "no-resize": "",
        "multi-line": "",
        "placeholder": "Escriba aquí",
        "rows": 7,
        "textarea": ""
      },
      model: {
        value: (_vm.bookingData.summary.personalInformation.specialRequest),
        callback: function($$v) {
          _vm.bookingData.summary.personalInformation.specialRequest = $$v
        },
        expression: "bookingData.summary.personalInformation.specialRequest"
      }
    })], 1)], 1) : (i === 2) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, _vm._l((_vm.localCategories), function(category) {
      return _c('v-flex', {
        key: category.id,
        staticClass: "filter-list",
        attrs: {
          "xs2": ""
        }
      }, [_c('v-btn', {
        staticClass: "mr-0",
        class: {
          'active': category.id === _vm.categoryValue
        },
        attrs: {
          "disabled": _vm.loading
        },
        on: {
          "click": function($event) {
            _vm.selectCategory(category.id)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(category.name) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-2": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      staticClass: "container-flex",
      attrs: {
        "xs2": ""
      }
    }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMonto Abonado\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset inline",
      attrs: {
        "type": "text",
        "disabled": true
      },
      model: {
        value: (_vm.summaryData.documentsAmountPayment),
        callback: function($$v) {
          _vm.summaryData.documentsAmountPayment = $$v
        },
        expression: "summaryData.documentsAmountPayment"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "container-flex",
      attrs: {
        "xs2": ""
      }
    }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tMonto Pendiente\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset inline",
      attrs: {
        "type": "text",
        "disabled": true
      },
      model: {
        value: (_vm.summaryData.documentsPendingAmount),
        callback: function($$v) {
          _vm.summaryData.documentsPendingAmount = $$v
        },
        expression: "summaryData.documentsPendingAmount"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "container-flex",
      attrs: {
        "xs2": ""
      }
    }, [_c('label', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tTotal\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset inline",
      attrs: {
        "type": "text",
        "disabled": true
      },
      model: {
        value: (_vm.summaryData.documentsAmount),
        callback: function($$v) {
          _vm.summaryData.documentsAmount = $$v
        },
        expression: "summaryData.documentsAmount"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('p', {
      staticClass: "title-form"
    }, [_vm._v("Filtro")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": "",
        "text-xs-left": "",
        "pt-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-left": 40,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIconProduct
      },
      model: {
        value: (_vm.menuProduct),
        callback: function($$v) {
          _vm.menuProduct = $$v
        },
        expression: "menuProduct"
      }
    }, [_c('v-text-field', {
      staticClass: "product-date-picker",
      attrs: {
        "label": "Fecha de creación",
        "prepend-icon": "event",
        "append-icon": _vm.arrowIconProduct,
        "append-icon-cb": _vm.toggleIconProductDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.createdAt),
        callback: function($$v) {
          _vm.createdAt = $$v
        },
        expression: "createdAt"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.createdAt),
        callback: function($$v) {
          _vm.createdAt = $$v
        },
        expression: "createdAt"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "text-xs-left": "",
        "pt-0": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-success white--text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.filterSummary
      }
    }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "justify-end": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.downloadSale
      }
    }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tImprimir Resumen\n\t\t\t\t\t\t\t\t\t\t")], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button",
        "disabled": Number(_vm.bookingData.bookingState) === 3
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openProductsModal($event)
        }
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar\n\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "persistent": "",
        "width": "auto"
      },
      model: {
        value: (_vm.dialog),
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    }, [_c('v-card', {
      attrs: {
        "height": "auto"
      }
    }, [_c('v-card-title', {
      staticClass: "headline"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tAgregar Producto\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-4": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-subheader', {
      staticClass: "pl-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAlmacenes\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "hide-details": "",
        "item-text": "name",
        "item-value": "id",
        "items": _vm.warehouses
      },
      model: {
        value: (_vm.productWarehouse),
        callback: function($$v) {
          _vm.productWarehouse = $$v
        },
        expression: "productWarehouse"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-subheader', {
      staticClass: "pl-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCategorías\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "hide-details": "",
        "item-text": "name",
        "item-value": "id",
        "items": _vm.categories
      },
      model: {
        value: (_vm.productCategory),
        callback: function($$v) {
          _vm.productCategory = $$v
        },
        expression: "productCategory"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": "",
        "pl-3": "",
        "text-xs-left": "",
        "pt-5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-success white--text",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.filterProducts
      }
    }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-5": ""
      }
    }, [_c('table-run', {
      attrs: {
        "columns": _vm.productColumns,
        "rows": _vm.productRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "key-value": "warProductId",
        "selectable": ""
      },
      on: {
        "on-search-event": _vm.searchProductsByColumn
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouseName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.stock))]), _vm._v(" "), _c('td', {
            staticClass: "px-2"
          }, [_c('v-text-field', {
            staticClass: "input-border-inset width-60",
            attrs: {
              "type": "number"
            },
            on: {
              "keyup": function($event) {
                _vm.positiveValue(props.row, 'quantity')
              }
            },
            model: {
              value: (props.row.quantity),
              callback: function($$v) {
                props.row.quantity = _vm._n($$v)
              },
              expression: "props.row.quantity"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v(_vm._s(props.row.price))]), _vm._v(" "), _c('td', {
            staticClass: "px-2 d-flex"
          }, [_c('v-text-field', {
            staticClass: "input-border-inset basis-30 mr-2",
            attrs: {
              "type": "number"
            },
            on: {
              "keyup": function($event) {
                _vm.positiveValue(props.row, 'discount')
              }
            },
            model: {
              value: (props.row.discount),
              callback: function($$v) {
                props.row.discount = _vm._n($$v)
              },
              expression: "props.row.discount"
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "basis-70"
          }, [_vm._v("%")])], 1)]
        }
      }])
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.totalModalPages,
        "total-visible": _vm.pagesVisible
      },
      on: {
        "input": function($event) {
          _vm.loadSummaryProducts(_vm.paramsSummary.page)
        }
      },
      model: {
        value: (_vm.paramsSummary.page),
        callback: function($$v) {
          _vm.paramsSummary.page = $$v
        },
        expression: "paramsSummary.page"
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-3": "",
        "align-end": "",
        "justify-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialog = false
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.addProductsDisabled
      },
      nativeOn: {
        "click": function($event) {
          _vm.updateProducts($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "total-amount"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tTotal $" + _vm._s(_vm._f("round")(_vm.totalAmount)) + "\n\t\t\t\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "my-2": ""
      }
    }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "pb-0": ""
      }
    }, [_c('table-run', {
      attrs: {
        "columns": _vm.summaryColumns,
        "rows": _vm.summaryRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(props.row.createdAt, 'HH:mm')) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [(props.row.product) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.product.code) + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [(props.row.product) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.product.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(props.row.subTotal)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.salDocumentsNumber))]), _vm._v(" "), _c('td', [_c('v-flex', {
            attrs: {
              "text-xs-right": ""
            }
          }, [_c('button', [(_vm.showAccommodationOption(props.row)) ? _c('img', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (props.row.product.name === 'ALOJAMIENTO'),
              expression: "props.row.product.name === 'ALOJAMIENTO'"
            }],
            attrs: {
              "src": "/static/img/divide.png",
              "alt": ""
            },
            on: {
              "click": function($event) {
                _vm.openModal(props.row.subTotal, props.row.idDetail, props.row.product.code)
              }
            }
          }) : _vm._e()]), _vm._v(" "), (_vm.showSummaryOption(props.row)) ? _c('v-btn', {
            staticClass: "error--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.deleteSummaryDetailConfirm(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)]
        }
      }])
    }), _vm._v(" "), _c('modal-bill', {
      attrs: {
        "amountTotal": _vm.modalSubTotal,
        "id-detail": _vm.modalDetail,
        "is-visible": _vm.visibleModal
      },
      on: {
        "close-modal": _vm.closeModal,
        "cancel-modal": _vm.cancelModal,
        "save-modal": _vm.saveModal
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-center": "",
        "my-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save btn-grey white--text",
      attrs: {
        "type": "button",
        "disabled": _vm.saleDisabled
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.openSaleModal($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.chargeBtnText) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "persistent": "",
        "width": "850px"
      },
      model: {
        value: (_vm.saleModal),
        callback: function($$v) {
          _vm.saleModal = $$v
        },
        expression: "saleModal"
      }
    }, [_c('v-card', {
      staticClass: "pb-5",
      attrs: {
        "height": "auto"
      }
    }, [_c('v-tabs', {
      staticClass: "checkin-tabs checkin-tabs-modal",
      model: {
        value: (_vm.salesTabs),
        callback: function($$v) {
          _vm.salesTabs = $$v
        },
        expression: "salesTabs"
      }
    }, [_c('v-tabs-bar', {
      staticClass: "transparent headline"
    }, [_c('v-tabs-slider', {
      staticClass: "default-skyblue"
    }), _vm._v(" "), _c('v-tabs-item', {
      attrs: {
        "href": "#tab-sales"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tVentas\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-tabs-item', {
      attrs: {
        "href": "#tab-customer"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNuevo Cliente\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
      staticClass: "pt-4",
      attrs: {
        "id": "tab-sales"
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [(_vm.alert) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "px-2": ""
      }
    }, [_c('v-alert', {
      staticClass: "text-xs-left",
      attrs: {
        "info": _vm.alertInfo,
        "warning": _vm.alertWarning,
        "dismissible": ""
      },
      model: {
        value: (_vm.alert),
        callback: function($$v) {
          _vm.alert = $$v
        },
        expression: "alert"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.alertMessage) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.billingActive && !_vm.cantBilling) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": "",
        "pl-2": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-booking",
      attrs: {
        "label": "Exonerar impuestos",
        "color": "info",
        "hide-details": ""
      },
      on: {
        "change": _vm.validateExoneration
      },
      model: {
        value: (_vm.flagTaxes),
        callback: function($$v) {
          _vm.flagTaxes = $$v
        },
        expression: "flagTaxes"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('label', {
      staticClass: "label-sale-modal"
    }, [_vm._v("Tipo de documento")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [(_vm.documentTypes.length > 0) ? _c('v-radio-group', {
      attrs: {
        "row": ""
      },
      on: {
        "change": _vm.setTypeDocument
      },
      model: {
        value: (_vm.saleModel.typeDocumentCode),
        callback: function($$v) {
          _vm.saleModel.typeDocumentCode = $$v
        },
        expression: "saleModel.typeDocumentCode"
      }
    }, [_c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "label": _vm.documentTypes[0].documentType.name,
        "value": _vm.documentTypes[0].documentType.code
      }
    }), _vm._v(" "), _c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "disabled": _vm.cantBilling,
        "label": _vm.documentTypes[1].documentType.name,
        "value": _vm.documentTypes[1].documentType.code
      }
    }), _vm._v(" "), _c('v-radio', {
      staticClass: "sale-radio-button",
      attrs: {
        "color": "info",
        "label": _vm.documentTypes[2].documentType.name,
        "value": _vm.documentTypes[2].documentType.code
      }
    })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": "",
        "text-xs-left": ""
      }
    }, [_c('label', {
      staticClass: "label-sale-modal"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTipo de cambio\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "pr-3": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": function($event) {
          _vm.changeAmounts(_vm.currencySelected)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.changeAmounts(_vm.currencySelected)
        }
      },
      model: {
        value: (_vm.exchangeRate),
        callback: function($$v) {
          _vm.exchangeRate = $$v
        },
        expression: "exchangeRate"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "code",
        "item-value": "code",
        "label": "Moneda",
        "items": _vm.currencies,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": function($event) {
          _vm.validateExoneration(_vm.flagTaxes)
        }
      },
      model: {
        value: (_vm.currencySelected),
        callback: function($$v) {
          _vm.currencySelected = $$v
        },
        expression: "currencySelected"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "justify-end": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": "",
        "text-xs-right": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Recargo al Consumo")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number"
      },
      model: {
        value: (_vm.tip),
        callback: function($$v) {
          _vm.tip = $$v
        },
        expression: "tip"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "pl-2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.saleData.typeDocument),
        callback: function($$v) {
          _vm.saleData.typeDocument = $$v
        },
        expression: "saleData.typeDocument"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.searchCustomerSale($event)
        },
        "blur": _vm.searchCustomerSale
      },
      model: {
        value: (_vm.saleData.numDocument),
        callback: function($$v) {
          _vm.saleData.numDocument = $$v
        },
        expression: "saleData.numDocument"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      on: {
        "click": _vm.addCustomer
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAgregar Cliente\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "pl-3": "",
        "offset-xs1": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "input-checkbox input-booking",
      attrs: {
        "label": "Incluir los datos del Huésped",
        "color": "info",
        "hide-details": ""
      },
      model: {
        value: (_vm.flagShowCustomer),
        callback: function($$v) {
          _vm.flagShowCustomer = $$v
        },
        expression: "flagShowCustomer"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "pl-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "item-text": "name",
        "item-value": "code",
        "label": "Modo de pago",
        "items": _vm.paymentMethods,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      on: {
        "input": _vm.setPaymentMethod
      },
      model: {
        value: (_vm.saleModel.paymentMethodCode),
        callback: function($$v) {
          _vm.saleModel.paymentMethodCode = $$v
        },
        expression: "saleModel.paymentMethodCode"
      }
    })], 1), _vm._v(" "), (!_vm.creditPayment) ? _c('v-flex', {
      attrs: {
        "xs6": "",
        "pl-3": "",
        "pr-2": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select filter-select-multiple",
      attrs: {
        "chips": "",
        "hide-details": "",
        "item-text": "name",
        "item-value": "code",
        "disabled": _vm.invalid || _vm.invalidBol,
        "items": _vm.typePayments,
        "label": "Selecciona los tipos de pago a realizar",
        "multiple": "",
        "return-object": "",
        "single-line": ""
      },
      on: {
        "input": _vm.addPays,
        "click": _vm.openModal
      },
      model: {
        value: (_vm.typePaymentsSelected),
        callback: function($$v) {
          _vm.typePaymentsSelected = $$v
        },
        expression: "typePaymentsSelected"
      }
    })], 1) : _c('v-flex', {
      attrs: {
        "xs3": "",
        "px-3": ""
      }
    }, [_c('v-select', {
      staticClass: "filter-select",
      attrs: {
        "hide-details": "",
        "disabled": _vm.invalid || _vm.invalidBol,
        "items": _vm.numberDays,
        "label": "# Días",
        "single-line": ""
      },
      model: {
        value: (_vm.paymentDays),
        callback: function($$v) {
          _vm.paymentDays = $$v
        },
        expression: "paymentDays"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": "",
        "mt-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((_vm.paysByTypePayment), function(pay) {
      return _c('v-flex', {
        key: pay.code,
        attrs: {
          "xs2": "",
          "text-xs-left": "",
          "pr-2": ""
        }
      }, [_c('label', {
        staticClass: "label-form"
      }, [_vm._v(_vm._s(pay.name))]), _vm._v(" "), _c('v-text-field', {
        staticClass: "input-border-inset",
        attrs: {
          "type": "number"
        },
        model: {
          value: (pay.amount),
          callback: function($$v) {
            pay.amount = _vm._n($$v)
          },
          expression: "pay.amount"
        }
      })], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('div', {
      staticClass: "bar-data"
    }, [_c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCliente:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.documentTypeName) + ":\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.document))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTipo de Documento:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.saleCustomer.typeDocument))])])]), _vm._v(" "), _c('div', {
      staticClass: "bar-data-item"
    }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMoneda:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.currencySelected))])])])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-3": ""
      }
    }, [_c('table-run', {
      ref: "saleTable",
      refInFor: true,
      staticClass: "no-selectable-table width-auto",
      attrs: {
        "columns": _vm.localProductsColumns,
        "rows": _vm.newLocalProductsRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product.category.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.symbol) + " "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (props.row.price),
              expression: "props.row.price"
            }],
            staticClass: "input-edit",
            attrs: {
              "type": "number",
              "maxlength": "4",
              "pattern": "\\d{2}",
              "required": ""
            },
            domProps: {
              "value": (props.row.price)
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                props.row.price = $event.target.value
              }
            }
          }), _vm._v(" "), (props.row.product.flagIgvRequired) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Impuesto obligatorio'
              }),
              expression: "{ html: 'Impuesto obligatorio' }",
              arg: "top"
            }],
            staticClass: "warning--text",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twarning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.igvExonerated(props.row)) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Impuesto exonerado'
              }),
              expression: "{ html: 'Impuesto exonerado' }",
              arg: "top"
            }],
            staticClass: "warning--text",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twarning\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.discountPercentage) + "%")])]
        }
      }])
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": "",
        "mt-2": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": "",
        "text-xs-left": ""
      }
    }, [_c('label', [_vm._v("Observación:")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-textarea input-note mt-1",
      attrs: {
        "no-resize": "",
        "multi-line": "",
        "placeholder": "Escriba aquí",
        "rows": 2,
        "textarea": ""
      },
      model: {
        value: (_vm.commentary),
        callback: function($$v) {
          _vm.commentary = $$v
        },
        expression: "commentary"
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "wrap": "",
        "align-end": "",
        "justify-center": "",
        "mt-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.saleModal = false
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.$v.saleCustomer.$invalid ||
          _vm.disableGenerateSale || _vm.validateAmount ||
          _vm.invalid || _vm.disabledSave || _vm.$v.paymentDays.$invalid ||
          _vm.invalidBol
      },
      nativeOn: {
        "click": function($event) {
          _vm.generateSale($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-3": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action back btn-blue",
      attrs: {
        "disabled": _vm.$v.saleCustomer.$invalid ||
          _vm.validateAmount
      },
      nativeOn: {
        "click": function($event) {
          _vm.postPreview($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tPrevisualización\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
      staticClass: "pt-4",
      attrs: {
        "id": "tab-customer"
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "px-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Tipo de identificación")]), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select filter-select-indicator",
      attrs: {
        "item-text": "name",
        "item-value": "id",
        "items": _vm.typeDocuments,
        "hide-details": "",
        "single-line": "",
        "bottom": ""
      },
      model: {
        value: (_vm.newCustomerSale.documentType),
        callback: function($$v) {
          _vm.newCustomerSale.documentType = $$v
        },
        expression: "newCustomerSale.documentType"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset input-form-select",
      attrs: {
        "type": "text"
      },
      on: {
        "blur": _vm.searchCustomerNew
      },
      model: {
        value: (_vm.newCustomerSale.numDocument),
        callback: function($$v) {
          _vm.newCustomerSale.numDocument = $$v
        },
        expression: "newCustomerSale.numDocument"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.numDocument &&
      _vm.$v.newCustomerSale.numDocument.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEl número de documento es requerido\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$v.newCustomerSale.numDocument &&
      _vm.$v.newCustomerSale.numDocument.$invalid &&
      _vm.$v.newCustomerSale.numDocument.$params.minLength) ? _c('p', {
      staticClass: "caption red--text mb-0"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEs necesario ingresar " + _vm._s(_vm.$v.newCustomerSale.numDocument.$params.minLength.min) + " dígitos\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      class: {
        'xs8': !_vm.isNaturalPerson
      },
      attrs: {
        "xs4": "",
        "mb-3": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v(_vm._s(_vm.nameLabel))]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.newCustomerSale.name),
        callback: function($$v) {
          _vm.newCustomerSale.name = $$v
        },
        expression: "newCustomerSale.name"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.name &&
      _vm.$v.newCustomerSale.name.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.nameValidateMessage) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.isNaturalPerson) ? _c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Apellidos")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text",
        "placeholder": "Completos"
      },
      model: {
        value: (_vm.newCustomerSale.lastname),
        callback: function($$v) {
          _vm.newCustomerSale.lastname = $$v
        },
        expression: "newCustomerSale.lastname"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.lastname &&
      _vm.$v.newCustomerSale.lastname.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEl apellido es requerido\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "mb-3": "",
        "pr-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "email",
        "placeholder": "nombre@mail.com"
      },
      model: {
        value: (_vm.newCustomerSale.email),
        callback: function($$v) {
          _vm.newCustomerSale.email = $$v
        },
        expression: "newCustomerSale.email"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.email &&
      _vm.$v.newCustomerSale.email.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEl correo es requerido\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "mb-3": ""
      }
    }, [_c('label', {
      staticClass: "label-form"
    }, [_vm._v("Dirección")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.newCustomerSale.address),
        callback: function($$v) {
          _vm.newCustomerSale.address = $$v
        },
        expression: "newCustomerSale.address"
      }
    }), _vm._v(" "), (_vm.$v.newCustomerSale.address &&
      _vm.$v.newCustomerSale.address.$invalid) ? _c('span', {
      staticClass: "caption red--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tLa dirección es requerida\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-3": "",
        "align-end": "",
        "justify-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action",
      attrs: {
        "type": "button",
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.backToSales($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "disabled": _vm.$v.newCustomerSale.$invalid
      },
      nativeOn: {
        "click": function($event) {
          _vm.saveCustomer($event)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tRegistrar\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": "",
        "text-xs-left": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save white--text",
      attrs: {
        "type": "button",
        "disabled": _vm.checkoutDisabled
      },
      on: {
        "click": _vm.checkout
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tCheck out\n\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1) : (i === 3) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-5": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs10": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, _vm._l((_vm.filters), function(filter) {
      return _c('v-flex', {
        key: filter.id,
        staticClass: "filter-list",
        attrs: {
          "xs3": ""
        }
      }, [_c('v-btn', {
        class: {
          'active': filter.id === _vm.filterValue
        },
        attrs: {
          "disabled": _vm.loading
        },
        on: {
          "click": function($event) {
            _vm.selectFilter(filter.id)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t("), (filter.id === 1) ? _c('span', [_vm._v(_vm._s(_vm.quantityNotes.activeNotes))]) : _c('span', [_vm._v(_vm._s(_vm.quantityNotes.filedNotes))]), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t")])], 1)
    }))], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save btn-success",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addNotes
      }
    }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAgregar\n\t\t\t\t\t\t\t\t\t\t")], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.inputNote) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.saveNote($event)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "mb-2": ""
      }
    }, [_c('v-text-field', {
      staticClass: "input-textarea input-note",
      attrs: {
        "placeholder": "Añada notas aquí, pulse 'Enter' para guardar",
        "no-resize": "",
        "multi-line": "",
        "rows": 7,
        "textarea": ""
      },
      on: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.saveNote($event)
        }
      },
      model: {
        value: (_vm.note),
        callback: function($$v) {
          _vm.note = $$v
        },
        expression: "note"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "mt-2": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-save",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.actionNoteButton) + "\n\t\t\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table",
      attrs: {
        "columns": _vm.notesColumns,
        "rows": _vm.notesRows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-search": false,
        "include-switch": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      on: {
        "on-sortable-event": _vm.notesColumnSortableEvent
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v("Nota " + _vm._s(props.row.id) + " (" + _vm._s(props.row.note) + ")")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [(_vm.filterValue === 1) ? _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.saveNote(props.row)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/archive.svg"),
              "alt": ""
            }
          })]) : _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.saveNote(props.row)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/unarchive.svg"),
              "alt": ""
            }
          })]), _vm._v(" "), (_vm.filterValue === 1) ? _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.updateNote(props.row, 1)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/edit.svg"),
              "alt": ""
            }
          })]) : _vm._e(), _vm._v(" "), _c('v-btn', {
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.openDeleteConfirm(props.row.id)
              }
            }
          }, [_c('img', {
            attrs: {
              "src": (_vm.$imageS3 + "/housekeeping/delete.svg"),
              "alt": ""
            }
          })])], 1)]
        }
      }])
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": "",
        "mb-5": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.totalNotesPages,
        "total-visible": _vm.notesPagesVisible
      },
      on: {
        "input": function($event) {
          _vm.loadNotes(_vm.paramsNotes.page)
        }
      },
      model: {
        value: (_vm.paramsNotes.page),
        callback: function($$v) {
          _vm.paramsNotes.page = $$v
        },
        expression: "paramsNotes.page"
      }
    })], 1)], 1) : (i === 4) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('p', {
      staticClass: "title-form"
    }, [_vm._v("Filtro")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": "",
        "mb-3": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md5": "",
        "my-1": ""
      }
    }, [_c('v-layout', {
      staticClass: "calendar-range",
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md6": "",
        "pa-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-left": 40,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeIconStart
      },
      model: {
        value: (_vm.menu),
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    }, [_c('v-text-field', {
      staticClass: "product-date-picker",
      attrs: {
        "label": "Fecha inicial",
        "prepend-icon": "event",
        "append-icon": _vm.arrowIconStart,
        "append-icon-cb": _vm.toggleIconStartDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.startDate),
        callback: function($$v) {
          _vm.startDate = $$v
        },
        expression: "startDate"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.startDate),
        callback: function($$v) {
          _vm.startDate = $$v
        },
        expression: "startDate"
      }
    })], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md6": "",
        "pa-0": ""
      }
    }, [_c('v-menu', {
      staticClass: "menu-date-picker",
      attrs: {
        "lazy": "",
        "transition": "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-left": 40,
        "max-width": "290px"
      },
      on: {
        "input": _vm.changeEndIcon
      },
      model: {
        value: (_vm.menuEnd),
        callback: function($$v) {
          _vm.menuEnd = $$v
        },
        expression: "menuEnd"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Fecha final",
        "append-icon": _vm.arrowIconEnd,
        "append-icon-cb": _vm.toggleIconEndDate,
        "single-line": "",
        "hide-details": "",
        "readonly": ""
      },
      slot: "activator",
      model: {
        value: (_vm.endDate),
        callback: function($$v) {
          _vm.endDate = $$v
        },
        expression: "endDate"
      }
    }), _vm._v(" "), _c('v-date-picker', {
      attrs: {
        "no-title": "",
        "scrollable": ""
      },
      model: {
        value: (_vm.endDate),
        callback: function($$v) {
          _vm.endDate = $$v
        },
        expression: "endDate"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": "",
        "pr-5": ""
      }
    }, [_c('v-btn', {
      staticClass: "btn-action btn-success white--text",
      attrs: {
        "type": "button",
        "disabled": !_vm.startDate || !_vm.endDate
      },
      on: {
        "click": _vm.filterBookings
      }
    }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-run', {
      staticClass: "no-selectable-table",
      attrs: {
        "columns": _vm.columns,
        "rows": _vm.rows,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": true,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      on: {
        "on-sortable-event": _vm.columnSortableEvent,
        "on-search-event": _vm.searchByColumn
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.codeRoomtype) + "\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.room.data.codeRoom) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.customer.data.name) + "\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.customer.data.lastname) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(props.row.bookingStart)) + " - " + _vm._s(_vm._f("parseDate")(props.row.bookingEnd)) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.guests))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.numberNights))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.summary.promotion.currency) + " " + _vm._s(_vm._f("round")(props.row.total)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_c('v-btn', {
            staticClass: "success--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                _vm.downloadSale(props.row.room.data)
              }
            }
          }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)]
        }
      }])
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.totalHistoryPages,
        "total-visible": _vm.pagesVisibleHistory
      },
      on: {
        "input": function($event) {
          _vm.loadBookingHistory(_vm.paramsBookingHistory.page)
        }
      },
      model: {
        value: (_vm.paramsBookingHistory.page),
        callback: function($$v) {
          _vm.paramsBookingHistory.page = $$v
        },
        expression: "paramsBookingHistory.page"
      }
    })], 1)], 1) : (i === 5) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "mt-4": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table no-search-table",
      attrs: {
        "columns": _vm.emailColumns,
        "rows": _vm.emailRows,
        "include-search": false,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.sentDate, 'DD-MM-YYYY')))]), _vm._v(" "), _c('td', [(props.row.data) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.data.from) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [(props.row.data) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.data.to) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [(props.row.data) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.data.message) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('v-btn', {
            staticClass: "success--text",
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                _vm.previewEmail(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("visibility")])], 1)], 1)]
        }
      }])
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "text-xs-right": "",
        "mb-5": ""
      }
    }, [_c('v-pagination', {
      attrs: {
        "length": _vm.emailPages,
        "total-visible": _vm.emailVisiblePages
      },
      on: {
        "input": function($event) {
          _vm.loadEmails(_vm.emailParams.page)
        }
      },
      model: {
        value: (_vm.emailParams.page),
        callback: function($$v) {
          _vm.emailParams.page = $$v
        },
        expression: "emailParams.page"
      }
    })], 1)], 1) : _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "my-4": ""
      }
    }, [_c('table-run', {
      staticClass: "no-selectable-table no-search-table",
      attrs: {
        "columns": _vm.billingColumns,
        "rows": _vm.billingRows,
        "include-search": false,
        "include-delete": false,
        "include-export-to-excel": false,
        "include-options": false,
        "include-settings": false,
        "include-delete-single": false,
        "selectable": false
      },
      scopedSlots: _vm._u([{
        key: "rows",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.row.serie) + "-" + _vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTypeDocumentName(props.row)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.createdAt)))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.stateName) + "\n\t\t\t\t\t\t\t\t\t\t"), (props.row.showCanceled) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Factura Anulada'
              }),
              expression: "{ html: 'Factura Anulada' }",
              arg: "top"
            }],
            staticClass: "error-icon",
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("block")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(!props.row.flagAmountTotal &&
            props.row.showCancel) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Pagar'
              }),
              expression: "{ html: 'Pagar' }",
              arg: "top"
            }],
            staticClass: "info--text",
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                _vm.openBillingPay(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("payment")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Ver detalle'
              }),
              expression: "{ html: 'Ver detalle' }",
              arg: "top"
            }],
            staticClass: "success--text",
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                _vm.openBillingDetail(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("visibility")])], 1), _vm._v(" "), (props.row.showPrintCot) ? _c('v-btn', {
            directives: [{
              name: "tooltip",
              rawName: "v-tooltip:top",
              value: ({
                html: 'Imprimir Comanda'
              }),
              expression: "{ html: 'Imprimir Comanda' }",
              arg: "top"
            }],
            attrs: {
              "icon": ""
            },
            nativeOn: {
              "click": function($event) {
                $event.preventDefault();
                _vm.downLoadUniqueTicket(props.row)
              }
            }
          }, [_c('v-icon', [_vm._v("print")])], 1) : _vm._e()], 1)]
        }
      }])
    })], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.dialogNote),
      callback: function($$v) {
        _vm.dialogNote = $$v
      },
      expression: "dialogNote"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea eliminar la nota " + _vm._s(_vm.noteId) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelDeleteNote($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteNote($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tEliminar\n\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.dialogCustomer),
      callback: function($$v) {
        _vm.dialogCustomer = $$v
      },
      expression: "dialogCustomer"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea eliminar al huésped " + _vm._s(_vm.customerNumber) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelDeleteCustomer($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "pl-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteCustomer($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEliminar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    model: {
      value: (_vm.dialogBillingDetail),
      callback: function($$v) {
        _vm.dialogBillingDetail = $$v
      },
      expression: "dialogBillingDetail"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\tDetalle de Factura\n\t\t\t\t")]), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.billingDetailsColumns,
      "rows": _vm.billingDetails,
      "include-search": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-settings": false,
      "include-delete-single": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.documentId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("parseDate")(props.row.expirationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.amount), _vm.symbol)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.amountPayment), _vm.symbol)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm._f("round")(props.row.amountToPay), _vm.symbol)))])]
      }
    }])
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBillingDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "650"
    },
    model: {
      value: (_vm.dialogBillingPay),
      callback: function($$v) {
        _vm.dialogBillingPay = $$v
      },
      expression: "dialogBillingPay"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\tPagar Factura\n\t\t\t\t")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title black--text px-0"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tNº DOC: " + _vm._s(_vm.billingDetail.documentId) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "my-0 grey--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEl adelanto se realizó en moneda " + _vm._s(_vm.currencySelected) + "\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "success": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToBill(_vm.billingDetail.documentId)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tVer Detalle de Factura\n\t\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "mr-3": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Tipo de pago")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "item-text": "name",
      "item-value": "code",
      "items": _vm.typePayments,
      "hide-details": ""
    },
    model: {
      value: (_vm.billingTypePaymentCode),
      callback: function($$v) {
        _vm.billingTypePaymentCode = $$v
      },
      expression: "billingTypePaymentCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v("Cuenta Bancaria")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "disabled": _vm.bankAccountsDisabled,
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.bankAccounts,
      "single-line": ""
    },
    model: {
      value: (_vm.billingBankAccountId),
      callback: function($$v) {
        _vm.billingBankAccountId = $$v
      },
      expression: "billingBankAccountId"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.billingDetails), function(billDetail) {
    return _c('v-layout', {
      key: billDetail.id,
      attrs: {
        "wrap": "",
        "mt-4": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "text-xs-left": "",
        "pr-2": ""
      }
    }, [_c('label', {
      staticClass: "body-1 black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tTotal\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tDeuda\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "readonly": "",
        "value": _vm._f("currency")(_vm._f("round")(billDetail.amount), _vm.symbol)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "text-xs-left": "",
        "px-2": ""
      }
    }, [_c('label', {
      staticClass: "body-1 black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tPagado\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tMonto\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "readonly": "",
        "value": _vm._f("currency")(_vm._f("round")(billDetail.amountPayment), _vm.symbol)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": "",
        "text-xs-left": "",
        "pl-2": ""
      }
    }, [_c('label', {
      staticClass: "body-1 black--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tA pagar\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "caption ma-0 grey--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\tMonto\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('v-text-field', {
      staticClass: "input-border-inset",
      attrs: {
        "type": "number",
        "prefix": _vm.symbol
      },
      model: {
        value: (billDetail.amountToPay),
        callback: function($$v) {
          billDetail.amountToPay = _vm._n($$v)
        },
        expression: "billDetail.amountToPay"
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBillingDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "success": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.payBilling($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPagar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.dialogCancelBilling),
      callback: function($$v) {
        _vm.dialogCancelBilling = $$v
      },
      expression: "dialogCancelBilling"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea anular la factura " + _vm._s(_vm.billingNumber) + "?")]), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeBillingDialog($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelBilling($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAnular\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "auto"
    },
    model: {
      value: (_vm.summaryConfirm),
      callback: function($$v) {
        _vm.summaryConfirm = $$v
      },
      expression: "summaryConfirm"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\t\t¿Desea eliminar " + _vm._s(_vm.summaryName) + " del resumen de cuenta?")]), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "info": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSummaryConfirm($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "white--text darken-1",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteSummaryDetail($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEliminar\n\t\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [(!_vm.firstTabActive) ? _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action back btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToTab
    }
  }, [_vm._v("\n\t\t\t\tVolver\n\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.firstTabActive && _vm.showCheckLoyalty) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox",
    attrs: {
      "label": "Loyalty",
      "true-value": 1,
      "false-value": 0,
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.model.flagLoyalty),
      callback: function($$v) {
        _vm.model.flagLoyalty = $$v
      },
      expression: "model.flagLoyalty"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.firstTabActive && _vm.checkinActive) ? _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action save btn-success white--text",
    attrs: {
      "type": "button",
      "disabled": !_vm.isToday
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("\n\t\t\t\tCheck in\n\t\t\t")])], 1) : _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action back btn-blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToSummary
    }
  }, [_vm._v("\n\t\t\t\tVer resumen de cuenta\n\t\t\t")])], 1), _vm._v(" "), (_vm.firstTabActive && !_vm.isToday) ? _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action back",
    attrs: {
      "primary": "",
      "type": "button"
    },
    on: {
      "click": _vm.goToCalendar
    }
  }, [_vm._v("\n\t\t\t\tVolver al calendario\n\t\t\t")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6007a611","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/checkin/NewForm.vue
// module id = 1647
// module chunks = 23